export default __webpack_public_path__ + "images/breech_blue.c9616c4a03243c1d9bc1678b3130f6f5.png";